module.exports = __webpack_public_path__ + "img/bigwin-v2-jackpot-frame.3e91d921.png";